import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import HighSchoolService from "../../../Services/HighSchool.service";
import HighSchoolLookupModal from "./HighSchoolLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => HighSchoolService.search({
        ids: options === null || options === void 0 ? void 0 : options.ids,
        query: search || (options === null || options === void 0 ? void 0 : options.query),
        ceebCodes: options === null || options === void 0 ? void 0 : options.ceebCodes,
        names: options === null || options === void 0 ? void 0 : options.names,
        srcSystemIds: options === null || options === void 0 ? void 0 : options.srcSystemIds,
    }, { max: 20 }).then(({ data }) => data),
    label: "nameWithCeebCode",
    value: "id",
};
export const HighSchoolSearch = makeSearch(makeSearchArgs);
export const HighSchoolMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error - TS2322 - Type 'ComponentType<WithModalParams<LookupModalProps<HighSchool, any>>>' is not assignable to type 'ComponentType<never> | undefined'.
    lookupModal: HighSchoolLookupModal }));
